import * as React from 'react';
import { NumericFormat } from 'react-number-format';
import { cn } from '@/helpers/shadcn';

const inputClassName =
  'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input h-8 w-full min-w-0 rounded-md border bg-transparent px-2.5 py-1 text-sm shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive';

function Input({ className, type, ...props }) {
  return <input type={type} data-slot="input" className={cn(inputClassName, className)} {...props} />;
}

function NumericInput({ onChange, ref, ...props }) {
  // react-number-format fires onValueChange from a props-sync effect (not just on user input)
  // whenever the controlled `value` prop changes, so onChange must be treated as optional —
  // NumericInput is also used as a disabled/display-only formatted field with no change handler.
  const handleValueChange = (values) => {
    if (onChange) {
      onChange(values.value);
    }
  };

  return (
    <NumericFormat
      data-slot="numeric-input"
      getInputRef={ref}
      thousandSeparator=","
      customInput={Input}
      onValueChange={handleValueChange}
      onFocus={(e) => setTimeout(() => e.target.select(), 0)}
      onMouseUp={(e) => {
        e.preventDefault();
        e.target.select();
      }}
      {...props}
    />
  );
}

function MoneyInput({ ref, currencySymbol = '$', ...props }) {
  return <NumericInput data-slot="money-input" {...props} getInputRef={ref} prefix={currencySymbol} decimalScale={2} fixedDecimalScale />;
}

// Rejects any keystroke that would give the value a fractional part, for fields the
// api stores as integers. decimalScale={0} is not a substitute: it strips the decimal
// separator and keeps the digits after it, so typing '902.1' silently yields 9021.
const isIntegerValue = (values) => values.floatValue === undefined || Number.isInteger(values.floatValue);

function IntegerInput({ ref, ...props }) {
  return <NumericInput data-slot="integer-input" {...props} getInputRef={ref} isAllowed={isIntegerValue} />;
}

export { Input, inputClassName, NumericInput, MoneyInput, IntegerInput };
